import { createAction, props } from '@ngrx/store';
import type { OptOutItem } from '../state/opt-out.state';

export const FetchOptOutList = createAction('[Opt-Out] fetch list', props<{ rrp?: number, pageNumber: number }>());
export const FetchOptOutListSuccess = createAction('[Opt-Out] fetch success',
    props<{ list: OptOutItem[], pageNumber: number, totalRecords: number }>());
export const FetchOptOutListFailure = createAction('[Opt-Out] fetch error', props<{ error: any }>());
